// Built-in sticker pack: Fluent Emoji 3D by Microsoft (MIT), served from /stickers/fluent/<id>.webp.
// A sticker message carries only the id; the server accepts ids from this list only.
export const STICKER_PACK = 'fluent';
export const STICKER_IDS = [
  'balloon',
  'birthday-cake',
  'books',
  'cat-face',
  'check-mark-button',
  'cold-face',
  'dog-face',
  'exploding-head',
  'face-blowing-a-kiss',
  'face-screaming-in-fear',
  'face-with-monocle',
  'face-with-rolling-eyes',
  'face-with-tears-of-joy',
  'fire',
  'ghost',
  'glowing-star',
  'graduation-cap',
  'grinning-face',
  'hot-beverage',
  'hot-face',
  'hugging-face',
  'hundred-points',
  'light-bulb',
  'loudly-crying-face',
  'melting-face',
  'nerd-face',
  'panda',
  'party-popper',
  'partying-face',
  'pizza',
  'pleading-face',
  'rainbow',
  'red-heart',
  'relieved-face',
  'robot',
  'rocket',
  'rolling-on-the-floor-laughing',
  'saluting-face',
  'shushing-face',
  'sleeping-face',
  'smiling-face-with-halo',
  'smiling-face-with-heart-eyes',
  'smiling-face-with-hearts',
  'smiling-face-with-sunglasses',
  'sparkles',
  'sparkling-heart',
  'star-struck',
  'teddy-bear',
  'thinking-face',
  'trophy',
  'unicorn',
  'upside-down-face',
  'winking-face',
  'wrapped-gift',
  'zany-face'
] as const;
export type StickerId = (typeof STICKER_IDS)[number];
export const stickerUrl = (id: string): string => `/stickers/${STICKER_PACK}/${id}.webp`;
